import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatSnackBar } from '@angular/material';

import { OpcionModel } from '../Global/Opcion.model';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import {MchSeguimientoEstadoId, seguimientoEstadoEscrituraModel} from './seguimientoEstadoEscritura.model'


import { IfObservable } from 'rxjs/observable/IfObservable';
import { Console } from '@angular/core/src/console';

@Component({
	selector: 'SeguimientoEstadoEscrituraNew',
	templateUrl: './SeguimientoEstadoEscrituraNew.component.html'
})


export class SeguimientoEstadoEscrituraNewComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public form: FormGroup;
	public formErrors: any;
	public seguimientoEstado: seguimientoEstadoEscrituraModel;
	

	public registroSeguimientoEstadoEscritura;
	public mensaje: string;
	public principal: boolean;
	public guardando: boolean = false;
	
	public bloquearValor:boolean = true;

	public ocultar: boolean = false;
	public bloquear: boolean = false;

	constructor(private formBuilder: FormBuilder,
		private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();

		this.formErrors = {
			fecha: {},
			cusuario:{},
			observacion:{}
		}

		
		this.seguimientoEstado = new seguimientoEstadoEscrituraModel(new MchSeguimientoEstadoId("","","",""), new Date(),"","",0);
	}
	


	ngOnInit() {
		
		
            this._route.params.subscribe(params => {
                this.registroSeguimientoEstadoEscritura = [{
                    'cnumcont': params['cnumcont'],
                    'cprefijo': params['cprefijo'],
                    'videscritura': params['videscritura'],
                    'tipo': params['tipo'],
                }];
			})

			this.inicializarForm();
		}

	inicializarForm() {
		this.bloquear = true;
		this.form = this.formBuilder.group({

			cusuario: [{disabled: this.bloquear,value:''}, Validators.required],
			fecha: [{disabled: this.bloquear,value:''}, Validators.required],
			observacion : ['', Validators.required]
		});

		this.seguimientoEstado.fecha = new Date();
		this.seguimientoEstado.cusuario =  this._serviciosGenerales.seguridad.getInfoSesion().usuario;
		this.seguimientoEstado.id.videscritura = this.registroSeguimientoEstadoEscritura[0].videscritura;
		this.seguimientoEstado.id.cnumcont = this.registroSeguimientoEstadoEscritura[0].cnumcont;
		this.seguimientoEstado.id.cprefijo = this.registroSeguimientoEstadoEscritura[0].cprefijo;

	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


	guardar() {
		
		var d = new Date();
		this.seguimientoEstado.id.cid = d.getTime().toString();
		

					this._serviciosGenerales.post('guardar/seguimientoEstadoEscrituras', this.seguimientoEstado).subscribe(
						result => {
							this.openSnackBar("Proceso realizado con éxito", "X");
							this._router.navigate(['/Escritura', this.seguimientoEstado.id.cnumcont.trim(), this.seguimientoEstado.id.videscritura.trim(), this.seguimientoEstado.id.cprefijo.trim(),'2','2','2','2','2']);

						},
						error => {
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);
							this.openSnackBar("Ocurrió un error al momento de guardar la sucursal", "X");
						}
					)
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}
}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/CrearEscritura/SeguimientoEstadoEscrituraNew.component.ts